import { FC } from 'react';

export const Lightning: FC = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M9.24266 22C9.17869 22 9.11383 21.9857 9.05252 21.9556C8.85043 21.8564 8.74618 21.6159 8.8066 21.3884L10.9464 13.3418H8.45333C8.31101 13.3418 8.17709 13.2708 8.09143 13.1504C8.00577 13.0297 7.97832 12.8736 8.0175 12.7284L9.54728 3.34866C9.60306 3.14221 9.78081 3 9.98312 3H14.7252C14.8724 3 15.0103 3.07586 15.0953 3.20328C15.1803 3.33081 15.2016 3.49416 15.1527 3.64131L13.2024 9.49367H16.5467C16.714 9.49367 16.8679 9.59161 16.9467 9.74839C17.0255 9.90516 17.0164 10.0953 16.923 10.2428L9.61917 21.7871C9.53263 21.9239 9.38986 22 9.24266 22Z"
			fill="currentColor"
		/>
	</svg>
);
